// S5 numeración limpia: bajo locations.clean_numbering_enabled las órdenes no
// tienen order_number hasta volverse committed (disparadas a cocina o pagadas —
// trigger orders_x_assign_clean_number). Estos helpers cubren los dos huecos que
// eso abre: qué invoice mandar al procesador antes de tener número, y qué mostrar
// en UI para intentos que nunca lo tendrán.

/**
 * Referencia que viaja al procesador (invoice del push A77 / PAX) cuando la orden
 * aún no tiene número: los primeros 8 hex del order id. El webhook de North hace
 * el matching inverso (prefijo de UUID) cuando el invoice no es un order_number.
 * Con número presente se manda el número, igual que siempre.
 */
export function orderPaymentReference(orderId: string, orderNumber?: string | null): string {
  return orderNumber && orderNumber.length > 0 ? orderNumber : orderId.slice(0, 8)
}

/** Un invoice generado por orderPaymentReference sin número: 8 hex del UUID. */
export const UUID_PREFIX_INVOICE_RE = /^[0-9a-f]{8}$/i

/**
 * Número de orden para UI. "—" mientras la orden no está committed (intentos de
 * pago en curso o rechazados) — jamás interpolar order_number crudo en JSX si la
 * superficie puede mostrar órdenes no confirmadas.
 */
export function displayOrderNumber(orderNumber?: string | null): string {
  return orderNumber && orderNumber.length > 0 ? orderNumber : "—"
}
